import React, { useState, useContext, useEffect } from 'react';
import { FormItem, Button, FormContext, ButtonDelete } from '@digital/ui';
import { Icon, Modal } from 'antd';
import Upload, { UploadProps } from 'antd/lib/upload';

export default (props: { fileName?: string; url?: string; onRemove: Function; disabled?: boolean }) => {
  const { fileName, url, onRemove, disabled } = props;
  const [file, setFile] = useState();
  const { formProps } = useContext(FormContext);
  useEffect(() => {
    fileName && setFile([{ uid: '1', name: fileName, url: url }]);
  }, [fileName]);

  const uploadProps: UploadProps = {
    action: '',
    multiple: false,
    type: 'select',
    onRemove: _ => {
      if (disabled) return;
      if (fileName != undefined) {
        Modal.confirm({
          title: 'Deseja realmente excluir este arquivo?',
          async onOk() {
            await onRemove();
            setFile(null);
          },
        });
      } else {
        setFile(null);
      }
      formProps && formProps.setFieldValue('formData', null);
    },
    beforeUpload: file => {
      setFile([
        {
          uid: '1',
          name: file.name,
        },
      ]);
      formProps && formProps.setFieldValue('formData', file);
      return false;
    },
    headers: {
      authorization: 'authorization-text',
    },
  };

  return (
    <>
      <FormItem label="Anexo" name="file" span={12}>
        <Upload
          name="file"
          {...uploadProps}
          fileList={file}
          disabled={disabled}
          id={'file'}
        >
          <Button disabled={disabled}>
            <Icon type="upload" /> Adicionar arquivo
          </Button>
        </Upload>
      </FormItem>
    </>
  );
};
